import React from "react";

export const MobilityHub = [
  <div className="slideContainer slideContainerVideo">
    <h4 className="slideTitle">Shell EV charging hub</h4>
    <div class="video_container">
      <video width="320" height="240" controls>
        <source src="videos/Shell EV charging hub.mp4" type="video/mp4" />
      </video>
    </div>
    <div className="qrCode">
      <div className="qrText">
        <p>
          <span>Scan the QR code</span> to watch the video on YouTube.
        </p>
      </div>
      <div className="qrImage">
        <img src="images/qr/qr-mobility-hub-success-story-video-01.svg" width="auto" height="95px" alt="" />
      </div>
    </div>
  </div>,
  <div className="slideContainer slideContainerVideo">
    <h4 className="slideTitle">
      Powering the e-mobility movement | Shell NewMotion
    </h4>
    <div class="video_container">
      <video width="320" height="240" controls>
        <source
          src="videos/Powering the e-mobility movement   Shell NewMotion.mp4"
          type="video/mp4"
        />
      </video>
    </div>
    <div className="qrCode">
      <div className="qrText">
        <p>
          <span>Scan the QR code</span> to watch the video on YouTube.
        </p>
      </div>
      <div className="qrImage">
      <img src="images/qr/qr-mobility-hub-success-story-video-02.svg" width="auto" height="95px" alt="" />
      </div>
    </div>
  </div>,
  <div className="slideContainer slideContainerVideo">
    <h4 className="slideTitle">Shell partnership met Intergamma Unlisted</h4>
    <div class="video_container">
      <video width="320" height="240" controls>
        <source
          src="videos/Shell partnership met Intergamma.mp4"
          type="video/mp4"
        />
      </video>
    </div>
    <div className="qrCode">
      <div className="qrText">
        <p>
          <span>Scan the QR code</span> to watch the video on YouTube.
        </p>
      </div>
      <div className="qrImage">
      <img src="images/qr/qr-mobility-hub-success-story-video-03.svg" width="auto" height="95px" alt="" />
      </div>
    </div>
  </div>,
];
